var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98164 6.88317C4.14297 7.02755 4.48172 7.02755 4.64304 6.88317L8.03049 3.8437C8.08019 3.79896 8.11129 3.74506 8.12025 3.6882C8.1292 3.63134 8.11563 3.57382 8.08109 3.52225C8.04656 3.47067 7.99247 3.42713 7.92502 3.39663C7.85757 3.36612 7.77951 3.34989 7.69979 3.34979L6.00607 3.34979L6.00607 1.22216C6.00607 1.14155 5.96146 1.06424 5.88205 1.00724C5.80264 0.950238 5.69494 0.918216 5.58264 0.918216L3.04205 0.918216C2.92975 0.918216 2.82205 0.950238 2.74264 1.00724C2.66323 1.06424 2.61862 1.14155 2.61862 1.22216L2.61862 3.34979L0.924897 3.34979C0.84518 3.34989 0.767116 3.36612 0.699669 3.39663C0.632223 3.42713 0.578128 3.47067 0.543596 3.52225C0.509063 3.57382 0.495493 3.63134 0.504444 3.6882C0.513395 3.74506 0.544503 3.79896 0.594198 3.8437L3.98164 6.88317ZM3.04205 3.95768L3.46548 3.95768L3.46548 1.52611L5.15921 1.52611L5.15921 3.95768L6.81863 3.95768L4.31234 6.20659L1.80606 3.95768L3.04205 3.95768Z",
    fill: "#AEAEAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.9ad729b7e94b473a6aa496880f7108a2.svg";
export { ForwardRef as ReactComponent };